/* eslint-disable*/
import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import 'vue-material-design-icons/styles.css'

Vue.config.productionTip = false;
Vue.use(require('vue-cookies'))


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
